import React, { Component } from 'react';
import { Modal } from 'antd';
import demo from '../../../../../assets/contacts/setting/effect.jpg';

import './showDemoModal.less';

class ShowDemoModalView extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  render() {
    const { onCancel } = this.props;
    return (
      <Modal
        width={420}
        title="展示效果"
        visible
        centered
        footer={null}
        onCancel={onCancel}
        wrapClassName="show-demo-wrap"
      >
        <div>
          <img style={{width: 420}} src={demo} alt="demo"/>
        </div>
      </Modal>
    );
  }
}

export default ShowDemoModalView;
